import { IconButton, Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateInformacaoFaturamnetoColumnsDefinition
 */

type Props = {
    onActionEdit: (idFaturamento: number | null, openState: boolean) => void,
    onActionDelete: (idFaturamento: number | null, openState: boolean) => void,
};

export const GenerateInformacaoFaturamentoColumnsDefinition = ({
    onActionEdit,
    onActionDelete,
}: Props): GridColDef[] => {


    const computeItemStatusColor = (principal: boolean) => {
        switch (principal) {
            case true:
                return "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer bg-primary-green";
            case false:
                return "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer bg-red-500";
            default:
                return "w-7 h-7 flex items-center justify-center rounded-[4px] cursor-pointer bg-blue-500";
        }
    };

    const computeItemStatusDescription = (principal: boolean) => {
        switch (principal) {
            case true:
                return "Sim";
            case false:
                return "não";
            default:
                return "?";
        }
    };


    return [
        {
            field: "principal",
            filterable: false,
            headerName: "Principal",
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-center items-center" >
                    <Tooltip title={computeItemStatusDescription(params.value)}>
                        <div className={computeItemStatusColor(params.value)}>
                            <h1 className="text-white">{computeItemStatusDescription(params.value)}</h1>
                        </div>
                    </Tooltip>
                </div>
            )
        },
        {
            field: "nomeFantasia",
            filterable: false,
            headerName: "Nome Fantasia",
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-start items-start">
                    {params.value}
                </div>
            )
        },
        {
            field: "razaoSocial",
            filterable: false,
            headerName: "Razão Social",
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: (params) => (
                <div className="w-full h-full flex justify-start items-start">
                    {params.value}
                </div>
            )
        },
        {
            field: "cnpj",
            filterable: false,
            headerName: "CNPJ",
            minWidth: 80,
            width: 150,
            sortable: false,
        },
        {
            field: "cpf",
            filterable: false,
            headerName: "CPF",
            minWidth: 80,
            width: 120,
            sortable: false,
        },
        {
            field: "email",
            filterable: false,
            headerName: "Email",
            minWidth: 80,
            width: 150,
            sortable: false,
        },
        {
            field: "contato",
            filterable: false,
            headerName: "Contato",
            minWidth: 80,
            width: 130,
            sortable: false,
        },
        {
            field: 'idInformacaoFaturamento',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            minWidth: 100,
            width: 100,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2" >
                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        < IconButton onClick={() => onActionDelete(params.value, true)
                        }>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>
                    </div>
                );
            }
        }
    ];
}